var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.selectedNode.props.groups, function (group, index) {
        return _c("div", { key: index + "_g", staticClass: "group" }, [
          _c("div", { staticClass: "group-header" }, [
            _c("span", { staticClass: "group-name" }, [
              _vm._v("条件组 " + _vm._s(_vm.groupNames[index])),
            ]),
            _c(
              "div",
              { staticClass: "group-cp" },
              [
                _c("span", [_vm._v("组内条件关系：")]),
                _c("el-switch", {
                  attrs: {
                    "active-color": "#409EFF",
                    "inactive-color": "#c1c1c1",
                    "active-value": "AND",
                    "inactive-value": "OR",
                    "active-text": "且",
                    "inactive-text": "或",
                  },
                  model: {
                    value: group.groupType,
                    callback: function ($$v) {
                      _vm.$set(group, "groupType", $$v)
                    },
                    expression: "group.groupType",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "group-operation" },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom",
                      title: "选择审批条件",
                      width: "300",
                      trigger: "click",
                    },
                  },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        attrs: { "value-key": "id" },
                        model: {
                          value: group.cids,
                          callback: function ($$v) {
                            _vm.$set(group, "cids", $$v)
                          },
                          expression: "group.cids",
                        },
                      },
                      _vm._l(_vm.conditionList, function (condition, cindex) {
                        return _c(
                          "el-checkbox",
                          {
                            key: condition.id,
                            attrs: { label: condition.id },
                            on: {
                              change: function ($event) {
                                return _vm.conditionChange(cindex, group)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(condition.title) + " ")]
                        )
                      }),
                      1
                    ),
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    }),
                  ],
                  1
                ),
                _c("i", {
                  staticClass: "el-icon-delete",
                  on: {
                    click: function ($event) {
                      return _vm.delGroup(index)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "group-content" }, [
            group.conditions.length === 0
              ? _c("p", [_vm._v("点击右上角 + 为本条件组添加条件 ☝")])
              : _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: "condition-form",
                        refInFor: true,
                        attrs: { "label-width": "100px" },
                      },
                      _vm._l(group.conditions, function (condition, cindex) {
                        return _c(
                          "el-form-item",
                          { key: condition.id + "_" + cindex },
                          [
                            _c("ellipsis", {
                              attrs: {
                                slot: "label",
                                "hover-tip": "",
                                content: condition.title,
                              },
                              slot: "label",
                            }),
                            condition.valueType === _vm.ValueType.string
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "120px" },
                                        attrs: {
                                          size: "small",
                                          placeholder: "判断符",
                                        },
                                        on: {
                                          change: function ($event) {
                                            condition.value = []
                                          },
                                        },
                                        model: {
                                          value: condition.compare,
                                          callback: function ($$v) {
                                            _vm.$set(condition, "compare", $$v)
                                          },
                                          expression: "condition.compare",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "等于", value: "=" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "包含在",
                                            value: "IN",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.isSelect(condition.id)
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            condition.compare === "IN"
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "280px",
                                                    },
                                                    attrs: {
                                                      clearable: "",
                                                      multiple: "",
                                                      size: "small",
                                                      placeholder: "选择值",
                                                    },
                                                    model: {
                                                      value: condition.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          condition,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "condition.value",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.getOptions(
                                                      condition.id
                                                    ),
                                                    function (option, oi) {
                                                      return _c("el-option", {
                                                        key: oi,
                                                        attrs: {
                                                          label: option,
                                                          value: option,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "280px",
                                                    },
                                                    attrs: {
                                                      clearable: "",
                                                      size: "small",
                                                      placeholder: "选择值",
                                                    },
                                                    model: {
                                                      value: condition.value[0],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          condition.value,
                                                          0,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "condition.value[0]",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.getOptions(
                                                      condition.id
                                                    ),
                                                    function (option, oi) {
                                                      return _c("el-option", {
                                                        key: oi,
                                                        attrs: {
                                                          label: option,
                                                          value: option,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            condition.compare === "="
                                              ? _c("el-input", {
                                                  staticStyle: {
                                                    width: "280px",
                                                  },
                                                  attrs: {
                                                    placeholder: "输入比较值",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value: condition.value[0],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        condition.value,
                                                        0,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "condition.value[0]",
                                                  },
                                                })
                                              : _c("el-select", {
                                                  staticStyle: {
                                                    width: "280px",
                                                  },
                                                  attrs: {
                                                    multiple: "",
                                                    clearable: "",
                                                    filterable: "",
                                                    "allow-create": "",
                                                    size: "small",
                                                    placeholder:
                                                      "输入可能包含的值",
                                                  },
                                                  model: {
                                                    value: condition.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        condition,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "condition.value",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : condition.valueType === _vm.ValueType.number
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "120px" },
                                        attrs: {
                                          size: "small",
                                          placeholder: "判断符",
                                        },
                                        model: {
                                          value: condition.compare,
                                          callback: function ($$v) {
                                            _vm.$set(condition, "compare", $$v)
                                          },
                                          expression: "condition.compare",
                                        },
                                      },
                                      _vm._l(_vm.explains, function (exp) {
                                        return _c("el-option", {
                                          key: exp.value,
                                          attrs: {
                                            label: exp.label,
                                            value: exp.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                      },
                                      [
                                        _vm.conditionValType(
                                          condition.compare
                                        ) === 0
                                          ? _c("el-input", {
                                              staticStyle: { width: "280px" },
                                              attrs: {
                                                size: "small",
                                                placeholder: "输入比较值",
                                                type: "number",
                                              },
                                              model: {
                                                value: condition.value[0],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    condition.value,
                                                    0,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "condition.value[0]",
                                              },
                                            })
                                          : _vm.conditionValType(
                                              condition.compare
                                            ) === 1
                                          ? _c("el-select", {
                                              staticStyle: { width: "280px" },
                                              attrs: {
                                                multiple: "",
                                                filterable: "",
                                                "allow-create": "",
                                                size: "small",
                                                placeholder: "输入可能包含的值",
                                              },
                                              model: {
                                                value: condition.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    condition,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "condition.value",
                                              },
                                            })
                                          : _c(
                                              "span",
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "130px",
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    type: "number",
                                                    placeholder: "输入比较值",
                                                  },
                                                  model: {
                                                    value: condition.value[0],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        condition.value,
                                                        0,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "condition.value[0]",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  [
                                                    _vm._v(" ~ "),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "130px",
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        type: "number",
                                                        placeholder:
                                                          "输入比较值",
                                                      },
                                                      model: {
                                                        value:
                                                          condition.value[1],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            condition.value,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "condition.value[1]",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : condition.valueType === _vm.ValueType.user
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "item-desc",
                                        staticStyle: { "margin-right": "20px" },
                                      },
                                      [_vm._v("属于某部门 / 为某些人其中之一")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          icon: "el-icon-plus",
                                          type: "primary",
                                          round: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectUser(
                                              condition.value,
                                              "user"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("选择人员/部门")]
                                    ),
                                    _c("org-items", {
                                      model: {
                                        value: condition.value,
                                        callback: function ($$v) {
                                          _vm.$set(condition, "value", $$v)
                                        },
                                        expression: "condition.value",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : condition.valueType === _vm.ValueType.dept
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "item-desc",
                                        staticStyle: { "margin-right": "20px" },
                                      },
                                      [_vm._v("为某部门 / 某部门下的部门")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          icon: "el-icon-plus",
                                          type: "primary",
                                          round: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectUser(
                                              condition.value,
                                              "dept"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("选择部门")]
                                    ),
                                    _c("org-items", {
                                      model: {
                                        value: condition.value,
                                        callback: function ($$v) {
                                          _vm.$set(condition, "value", $$v)
                                        },
                                        expression: "condition.value",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : condition.valueType === _vm.ValueType.date
                              ? _c("span")
                              : _vm._e(),
                            _c("i", {
                              staticClass: "el-icon-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.rmSubCondition(group, cindex)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
          ]),
        ])
      }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { type: _vm.orgType, multiple: "", selected: _vm.users },
        on: { ok: _vm.selected },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }